import { restartableTask } from 'ember-concurrency';
import { POResourceName } from 'volta/models/planning-order';
import { SkuResourceName } from 'volta/models/sku';
import { inFilter } from 'volta/utils/filters-utils';

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { IWidgetArgs } from '../';

import type AuthorizationService from 'volta/services/authorization';
import type TaskService from 'volta/services/task-service';
import type { UTask } from 'volta/models/types/tasks';

export default class LastCommentsWidget extends Component<IWidgetArgs> {
  @service taskService!: TaskService;
  @service authorization!: AuthorizationService;

  @tracked comments: UTask[] = [];

  get authorizedEntityTypes() {
    return this.authorization.canViewAnyList(SkuResourceName.plural, POResourceName.plural);
  }

  getComments = restartableTask(async () => {
    this.comments = (await this.taskService.fetchTasks.perform({
      filter: {
        linkedEntityType: inFilter(this.authorizedEntityTypes),
        taskType: inFilter(['COMMENT'])
      },
      sort: '-updatedAt'
    })).toArray();
  });
}
